<template>
  <Modal title="表示設定" @close="close">
    <template #content>
      <div class="reserve-history-modal">
        <dl class="values">
          <dt>フリーワード</dt>
          <dd>
            <TextInput
              v-model="text"
              class="search-text"
              placeholder="ご予約者名、電話番号、会社名などを入力してください。"
            />
          </dd>
          <dt>並び順</dt>
          <dd><RadioList :items="dateTypeMap" v-model.number="dateType" /></dd>
          <dt>期間</dt>
          <dd class="dates">
            <CalendarInput
              v-model="startDate"
              isSP
              :holidayList="holidayList"
              :businessDay="businessDay"
              :popperOptions="popperOptions"
              :reserveCalendar="reserveCalendar"
              :busy="busy"
              @setDate="setDate"
              @beforeShow="setDate(startDate)"
            />
            <span>〜</span>
            <CalendarInput
              v-model="endDate"
              isSP
              :holidayList="holidayList"
              :businessDay="businessDay"
              :popperOptions="popperOptions"
              :reserveCalendar="reserveCalendar"
              :busy="busy"
              @setDate="setDate"
              @beforeShow="setDate(endDate)"
            />
          </dd>
          <dt>ステータス</dt>
          <dd>
            <ul class="radio-buttons">
              <li v-for="(label, index) in statusMap" :key="index">
                <label :class="{ 'is-selected': +index === status }">
                  <RadioButton name="status" :value="index" v-model.number="status" />
                  {{ label }}
                </label>
              </li>
            </ul>
          </dd>
          <dt>入力者</dt>
          <dd>
            <ul class="radio-buttons">
              <li v-for="[key, label] in Array.from(mediumMap)" :key="key">
                <label :class="{ 'is-selected': +key === inputBy }">
                  <RadioButton name="medium" :value="key" v-model.number="inputBy" />{{ label }}
                </label>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </template>
    <template #footer-center>
      <Button @click="close">閉じる</Button>
      <Button @click="search" primary>表示</Button>
    </template>
  </Modal>
</template>

<script>
import { models } from '@/utils/vue'
import TextInput from '@/components/atoms/TextInput'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import CalendarInput from '@/components/molecules/CalendarInput'
import RadioList from '@/components/atoms/RadioList'
import RadioButton from '@/components/atoms/RadioButton'

export default {
  name: 'ReserveHistoryModal',
  components: {
    Modal,
    TextInput,
    Button,
    CalendarInput,
    RadioList,
    RadioButton,
  },
  props: {
    condition: Object,
    holidayList: Array,
    businessDay: Object,
    mediumMap: Map,
    dateTypeMap: Object,
    statusMap: Object,
    /** 予約数一覧 */
    reserveCalendar: { type: Object, default: () => ({}) },
    /** ローディング */
    busy: { type: Boolean, default: false },
  },
  computed: {
    ...models(
      ['inputBy', 'status', 'dateType', 'text'],
      ({ condition }, key) => condition[key],
      (vm, key, value) => vm.$emit('updateCondition', { [key]: value }),
    ),
    startDate: {
      get() {
        return this.condition.startDate
      },
      set(value) {
        this.updateStartDate(value)
      },
    },
    endDate: {
      get() {
        return this.condition.endDate
      },
      set(value) {
        this.updateEndDate(value)
      },
    },
    popperOptions: () => ({
      modifiers: {
        flip: { enabled: false },
        preventOverflow: { priority: ['left', 'right'] },
      },
    }),
  },
  methods: {
    updateStartDate(date) {
      this.$emit('updateStartDate', date)
    },
    updateEndDate(date) {
      this.$emit('updateEndDate', date)
    },
    close() {
      this.$emit('close')
    },
    search() {
      this.close()
      this.$emit('search')
    },
    setDate(date) {
      this.$emit('setDate', date)
    },
  },
}
</script>

<style lang="postcss" scoped>
.reserve-history-modal {
  margin: 26px 16px;
}

.values {
  dt {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  dd {
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    margin-bottom: 26px;
  }
}

.search-text {
  font-size: 12px;
  &::placeholder {
    color: var(--light-gray);
  }
}

.dates {
  font-size: 13px;
  grid-gap: 8px;
  grid-template-columns: 1fr auto 1fr;
}

.radio-buttons li {
  border-top: solid 1px var(--very-light-gray-3);
  color: var(--very-dark-gray-2);
  padding: 20px 0;

  .is-selected {
    font-weight: bold;
  }

  &:last-of-type {
    border-bottom: solid 1px var(--very-light-gray-3);
  }

  & > label {
    align-items: center;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: max-content 1fr;
  }
}
</style>
